import { useState } from 'react';
import CreatorSidebar from '../../components/feature/CreatorSidebar';

interface Subscriber {
  id: number;
  name: string;
  avatar: string;
  startDate: string;
  level: number;
  levelAmount: string;
  totalTips: string;
  balance: string;
}

interface Message {
  id: number;
  text: string;
  sender: 'me' | 'fan';
  time: string;
  isRead: boolean;
}

export default function Subscribers() {
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('level');
  const [selectedSubscriber, setSelectedSubscriber] = useState<Subscriber | null>(null);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [messageText, setMessageText] = useState('');

  const subscribers: Subscriber[] = [
    { id: 1, name: '민지팬', avatar: 'https://public.readdy.ai/ai/img_res/4a094318ec47e75298fec34be50cb217.jpg', startDate: '2024-01-15', level: 5, levelAmount: '50,000원', totalTips: '250,000원', balance: '30,000원' },
    { id: 2, name: '하니러버', avatar: 'https://readdy.ai/api/search-image?query=cute%20korean%20boy%20profile%20photo%20pastel%20purple%20background%20simple%20clean%20aesthetic%20portrait%20style&width=100&height=100&seq=sub2&orientation=squarish', startDate: '2024-02-20', level: 4, levelAmount: '20,000원', totalTips: '180,000원', balance: '15,000원' },
    { id: 3, name: '혜인최애', avatar: 'https://readdy.ai/api/search-image?query=cute%20korean%20girl%20profile%20photo%20pastel%20blue%20background%20simple%20clean%20aesthetic%20portrait%20style&width=100&height=100&seq=sub3&orientation=squarish', startDate: '2024-03-10', level: 3, levelAmount: '10,000원', totalTips: '95,000원', balance: '8,000원' },
    { id: 4, name: '다니엘팬', avatar: 'https://readdy.ai/api/search-image?query=cute%20korean%20boy%20profile%20photo%20pastel%20pink%20background%20simple%20clean%20aesthetic%20portrait%20style&width=100&height=100&seq=sub4&orientation=squarish', startDate: '2024-03-25', level: 5, levelAmount: '50,000원', totalTips: '320,000원', balance: '45,000원' },
    { id: 5, name: '해린사랑', avatar: 'https://readdy.ai/api/search-image?query=cute%20korean%20girl%20profile%20photo%20pastel%20purple%20background%20simple%20clean%20aesthetic%20portrait%20style&width=100&height=100&seq=sub5&orientation=squarish', startDate: '2024-04-05', level: 2, levelAmount: '5,000원', totalTips: '35,000원', balance: '5,000원' },
  ];

  const messages: Record<number, Message[]> = {
    1: [
      { id: 1, text: '안녕하세요! 항상 응원합니다 💕', sender: 'fan', time: '오전 10:30', isRead: true },
      { id: 2, text: '감사합니다! 앞으로도 좋은 콘텐츠로 보답할게요!', sender: 'me', time: '오전 10:35', isRead: true },
      { id: 3, text: '다음 콘텐츠 언제 올라오나요?', sender: 'fan', time: '오후 2:20', isRead: true },
      { id: 4, text: '이번 주말에 올릴 예정이에요 😊', sender: 'me', time: '오후 2:25', isRead: true },
    ],
    2: [
      { id: 1, text: '구독했어요! 잘 부탁드려요', sender: 'fan', time: '어제', isRead: true },
      { id: 2, text: '환영합니다! 감사해요 🎉', sender: 'me', time: '어제', isRead: true },
    ],
    3: [
      { id: 1, text: '후원 보냈습니다! 화이팅!', sender: 'fan', time: '2일 전', isRead: true },
      { id: 2, text: '정말 감사합니다! 힘이 됩니다 💪', sender: 'me', time: '2일 전', isRead: true },
    ],
    4: [
      { id: 1, text: '오늘 라이브 방송 하시나요?', sender: 'fan', time: '3일 전', isRead: true },
      { id: 2, text: '네! 오후 8시에 시작할게요', sender: 'me', time: '3일 전', isRead: true },
      { id: 3, text: '기대할게요!', sender: 'fan', time: '3일 전', isRead: true },
    ],
    5: [
      { id: 1, text: '새로운 구독자입니다!', sender: 'fan', time: '1주일 전', isRead: true },
      { id: 2, text: '반갑습니다! 앞으로 잘 부탁드려요 😊', sender: 'me', time: '1주일 전', isRead: true },
    ],
  };

  const filteredSubscribers = subscribers
    .filter(sub => sub.name.toLowerCase().includes(searchTerm.toLowerCase()))
    .sort((a, b) => {
      if (sortBy === 'level') return b.level - a.level;
      if (sortBy === 'tips') return parseInt(b.totalTips.replace(/[^0-9]/g, '')) - parseInt(a.totalTips.replace(/[^0-9]/g, ''));
      return 0;
    });

  const handleSendMessage = () => {
    if (!messageText.trim()) return;
    
    alert('메시지가 전송되었습니다!');
    setMessageText('');
  };

  const openMessageModal = (subscriber: Subscriber) => {
    setSelectedSubscriber(subscriber);
    setShowMessageModal(true);
  };

  const closeMessageModal = () => {
    setShowMessageModal(false);
    setMessageText('');
  };

  const currentMessages = selectedSubscriber ? messages[selectedSubscriber.id] || [] : [];

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-pink-50 to-purple-50">
      <CreatorSidebar />
      
      <div className="lg:ml-64 p-4 lg:p-8">
        <div className="max-w-7xl mx-auto">
          {/* 헤더 */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-2">구독자 관리</h1>
            <p className="text-gray-600">총 {subscribers.length}명의 구독자가 있습니다</p>
          </div>

          {/* 검색 및 정렬 */}
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 border border-pink-100 shadow-lg mb-6">
            <div className="flex flex-col md:flex-row gap-4">
              <div className="flex-1 relative">
                <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-lg"></i>
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="구독자 검색..."
                  className="w-full pl-12 pr-4 py-3 rounded-xl border border-gray-200 focus:border-pink-400 focus:ring-2 focus:ring-pink-200 outline-none transition-all text-sm"
                />
              </div>
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="px-4 py-3 rounded-xl border border-gray-200 focus:border-pink-400 focus:ring-2 focus:ring-pink-200 outline-none transition-all text-sm cursor-pointer"
              >
                <option value="level">레벨순</option>
                <option value="tips">수익순</option>
              </select>
            </div>
          </div>

          {/* 구독자 테이블 */}
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl border border-pink-100 shadow-lg overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gradient-to-r from-pink-50 to-purple-50">
                  <tr>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">구독자</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">구독 시작</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">레벨</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">총 팁</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">충전금</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">액션</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {filteredSubscribers.map((subscriber) => (
                    <tr key={subscriber.id} className="hover:bg-pink-50/50 transition-all">
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-3">
                          <div className="w-12 h-12 rounded-full overflow-hidden">
                            <img src={subscriber.avatar} alt={subscriber.name} className="w-full h-full object-cover" />
                          </div>
                          <span className="font-semibold text-gray-800">{subscriber.name}</span>
                        </div>
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-600">{subscriber.startDate}</td>
                      <td className="px-6 py-4">
                        <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-gradient-to-r from-pink-400 to-purple-400 text-white text-sm font-semibold">
                          <i className="ri-vip-crown-fill"></i>
                          레벨 {subscriber.level}
                        </span>
                      </td>
                      <td className="px-6 py-4 text-sm font-semibold text-gray-800">{subscriber.totalTips}</td>
                      <td className="px-6 py-4 text-sm text-gray-600">{subscriber.balance}</td>
                      <td className="px-6 py-4">
                        <button
                          onClick={() => openMessageModal(subscriber)}
                          className="px-4 py-2 bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-lg text-sm font-semibold hover:from-pink-600 hover:to-purple-600 transition-all whitespace-nowrap cursor-pointer"
                        >
                          메시지
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* 메시지 모달 */}
      {showMessageModal && selectedSubscriber && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-3xl max-w-2xl w-full h-[80vh] flex flex-col">
            {/* 헤더 */}
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full overflow-hidden">
                  <img src={selectedSubscriber.avatar} alt={selectedSubscriber.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-800">{selectedSubscriber.name}</h3>
                  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-gradient-to-r from-pink-400 to-purple-400 text-white text-xs font-semibold">
                    <i className="ri-vip-crown-fill"></i>
                    레벨 {selectedSubscriber.level}
                  </span>
                </div>
              </div>
              <button
                onClick={closeMessageModal}
                className="w-10 h-10 rounded-full hover:bg-gray-100 flex items-center justify-center transition-all cursor-pointer"
              >
                <i className="ri-close-line text-2xl text-gray-600"></i>
              </button>
            </div>

            {/* 메시지 영역 */}
            <div className="flex-1 overflow-y-auto p-6 space-y-4">
              {currentMessages.map((message) => (
                <div
                  key={message.id}
                  className={`flex ${message.sender === 'me' ? 'justify-end' : 'justify-start'}`}
                >
                  <div className={`max-w-[70%] ${message.sender === 'me' ? 'order-2' : 'order-1'}`}>
                    <div
                      className={`px-4 py-2 rounded-2xl ${
                        message.sender === 'me'
                          ? 'bg-gradient-to-r from-pink-500 to-purple-500 text-white'
                          : 'bg-gray-100 text-gray-800'
                      }`}
                    >
                      <p className="text-sm">{message.text}</p>
                    </div>
                    <div className={`flex items-center gap-1 mt-1 text-xs text-gray-500 ${message.sender === 'me' ? 'justify-end' : 'justify-start'}`}>
                      <span>{message.time}</span>
                      {message.sender === 'me' && (
                        <i className={`${message.isRead ? 'ri-check-double-line text-pink-500' : 'ri-check-line'}`}></i>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* 메시지 입력 */}
            <div className="p-6 border-t border-gray-200">
              <div className="flex items-end gap-3">
                <button className="w-10 h-10 flex items-center justify-center hover:bg-gray-100 rounded-full transition-colors flex-shrink-0 cursor-pointer">
                  <i className="ri-image-add-line text-xl text-gray-600"></i>
                </button>
                <div className="flex-1">
                  <textarea
                    value={messageText}
                    onChange={(e) => setMessageText(e.target.value)}
                    placeholder="메시지를 입력하세요..."
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-pink-500 resize-none text-sm"
                    rows={1}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter' && !e.shiftKey) {
                        e.preventDefault();
                        handleSendMessage();
                      }
                    }}
                  />
                </div>
                <button
                  onClick={handleSendMessage}
                  disabled={!messageText.trim()}
                  className="w-10 h-10 bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-full flex items-center justify-center hover:shadow-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed flex-shrink-0 cursor-pointer"
                >
                  <i className="ri-send-plane-fill"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}